'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis({}.isPrototypeOf);



//////////////////
// WEBPACK FOOTER
// ./~/react-fileupload-progress/~/core-js/internals/object-is-prototype-of.js
// module id = 289
// module chunks = 0